// extracted by mini-css-extract-plugin
export default {"box":"Card_box__0fWFa","text":"Card_text__ZCaDS","image":"Card_image__g5L-L","info":"Card_info__RG+6A","name":"Card_name__Xw58-","role":"Card_role__MDUjl"};